import { ICampaign } from '@unfoldrtech/portal-mic'
import { createContext } from 'react'
import { TCampaignContext } from '../types'

export const defaultCampaignContext: TCampaignContext = <ICampaign>{}

export const CampaignContext = createContext<TCampaignContext>(
  defaultCampaignContext
)
